import {CdkScrollable} from '@angular/cdk/scrolling';
import {CommonModule} from '@angular/common';
import {HttpClient} from '@angular/common/http';
import {
  CUSTOM_ELEMENTS_SCHEMA,
  NgModule,
  NO_ERRORS_SCHEMA,
} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {RouterModule} from '@angular/router';
import {UtilsModule} from '@gatewee/utils';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {TranslateModule} from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {
  TuiTableCell,
  TuiTableDirective,
  TuiTableTbody,
  TuiTableTd,
  TuiTableTh,
} from '@taiga-ui/addon-table';
import {TuiTitle} from '@taiga-ui/core';
import {TuiCell} from '@taiga-ui/layout';
import {NgOtpInputComponent} from 'ng-otp-input';
import {NgxMaskDirective, provideNgxMask} from 'ngx-mask';

// Material Libs
import {MaterialModule} from '@gatewee/material';

// V1
import {GateweeDatepickerRangeComponent} from '../v2/gatewee-datepicker-range/gatewee-datepicker-range.component';
import {GateweeDatepickerV2Component} from '../v2/gatewee-datepicker-v2/gatewee-datepicker-v2.component';
import {GateweeIconComponent} from '../v2/gatewee-icon/gatewee-icon.component';
import {GateweeInputV2Component} from '../v2/gatewee-input-v2/gatewee-input-v2.component';
import {GateweeSelectV3Component} from '../v2/gatewee-select-v3/gatewee-select-v3.component';
import {CustomPaginationComponent} from './custom-pagination/custom-pagination.component';
import {ElementSpinnerComponent} from './element-spinner/element-spinner.component';
import {ErrorMessageComponent} from './error-component/error-message.component';
import {Date1Component} from './filter-head/date1/date1.component';
import {FilterHeadComponent} from './filter-head/filter-head.component';
import {GateweeDatepickerComponent} from './gatewee-datepicker/gatewee-datepicker.component';
import {GateweeGenericModalComponent} from './gatewee-generic-modal/gatewee-generic-modal.component';
import {GateweeInputComponent} from './gatewee-input/gatewee-input.component';
import {GateweeSelect2Component} from './gatewee-select2/gatewee-select2.component';
import {GateweeSkeletonComponent} from './gatewee-skeleton/gatewee-skeleton.component';
import {GateweeTableModalComponent} from './gatewee-table-modal/gatewee-table-modal.component';
import {GateweeTableComponent} from './gatewee-table/gatewee-table.component';
import {IncomeCardComponent} from './income-card/income-card.component';
import {IncomeIconComponent} from './income-icon/income-icon.component';
import {InvoicesByPaymentComponent} from './invoices-by-payment/invoices-by-payment.component';
import {MetricCardComponent} from './metric-card/metric-card.component';
import {NameDocumentTableitemComponent} from './name-document-tableitem/name-document-tableitem.component';
import {OutcomeIconComponent} from './outcome-icon/outcome-icon.component';
import {ProfileImageComponent} from './profile-image/profile-image.component';
import {RecentTransactionsComponent} from './recent-transactions/recent-transactions.component';
import {WalletCardComponent} from './wallet-card/wallet-card.component';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, '/assets/i18n/', '.json');
}

const components = [
  NameDocumentTableitemComponent,
  ProfileImageComponent,
  IncomeIconComponent,
  OutcomeIconComponent,
  GateweeSelect2Component,
  GateweeDatepickerComponent,
  GateweeTableComponent,
  CustomPaginationComponent,
  GateweeGenericModalComponent,
  FilterHeadComponent,
  Date1Component,
  WalletCardComponent,
  RecentTransactionsComponent,
  IncomeCardComponent,
  ElementSpinnerComponent,
  InvoicesByPaymentComponent,
  MetricCardComponent,
  GateweeTableModalComponent,
];

const imports = [
  CommonModule,
  RouterModule,
  UtilsModule,
  ReactiveFormsModule,
  FormsModule,
  NgxMaskDirective,
  CdkScrollable,
  NgbModule,
  TuiTableDirective,
  TuiTableTh,
  TuiTableTd,
  TuiTableTbody,
  TuiTableCell,
  TuiTitle,
  TuiCell,
  NgOtpInputComponent,
  MaterialModule,
  GateweeIconComponent,
  ErrorMessageComponent,
  GateweeInputComponent,
  GateweeSkeletonComponent,
  GateweeSelectV3Component,
  GateweeDatepickerV2Component,
  GateweeDatepickerRangeComponent,
  GateweeInputV2Component,
];

@NgModule({
  declarations: [...components],
  imports: [...imports, TranslateModule.forChild()],
  providers: [provideNgxMask()],
  exports: [
    ...components,
    ErrorMessageComponent,
    GateweeInputComponent,
    GateweeSkeletonComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
})
export class ComponentsV1Module {}
